import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItem'

export default defineMessages({
  listPriceLabel: {
    id: `${scope}.listPriceLabel`,
    defaultMessage: 'List:',
  },
})
